import React, { useState } from "react";
import JoinForm from "./JoinForm";
import { setSession, validSession } from "../../bandung";
import useTextField from "../../hooks/useTextField";
import { sessionJoin } from "../../api/session";
import useInfoSnackbar from "../../hooks/useInfoSnackbar";
import { Navigate, useNavigate } from "react-router-dom";
import { Paper, styled } from "@mui/material";
import JoinHeader from "./JoinHeader";

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: clamp(280px, 100%, 600px);
  height: 100%;
  padding: 3em 0;
`;

const JoinComponent = ({
  header,
  navigateAwayPath,
  ...props
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const email = useTextField();
  const emailRepeat = useTextField();
  const password = useTextField();
  const passwordRepeat = useTextField();
  const [termsChecked, setTermsChecked] = useState(false);
  const infoSnackbar = useInfoSnackbar();
  const navigate = useNavigate();

  const handleJoinSubmit = async (event) => {
    event.preventDefault();
    const response = await sessionJoin(
      firstName,
      lastName,
      email.value,
      emailRepeat.value,
      password.value,
      passwordRepeat.value,
    );
    switch (response.code) {
      case "SUCCESS":
        setSession(response.data);
        navigate(navigateAwayPath ?? "/", { replace: true });
        break;
      case "EMAIL_MISMATCH":
        email.alertError(response.message);
        emailRepeat.alertError();
        break;
      case "PASSWORD_MISMATCH":
      case "INVALID_PASSWORD":
        password.alertError(response.message);
        passwordRepeat.alertError();
        break;
      default:
        infoSnackbar.alertError(response.message);
        break;
    }
  };

  const resetErrors = () => {
    email.resetError();
    emailRepeat.resetError();
    password.resetError();
    passwordRepeat.resetError();
  };

  const handleInputChange = (event, setter) => {
    setter(event.target.value);
    resetErrors();
  };

  const handleTermsChecked = (event) => {
    setTermsChecked(event.target.checked);
  };

  if (validSession()) return <Navigate to={navigateAwayPath} replace/>;

  return (
    <StyledPaper {...props}>
      <JoinHeader children={header}/>
      <JoinForm
        firstName={firstName}
        onFirstNameChanged={setFirstName}
        lastName={lastName}
        onLastNameChanged={setLastName}
        email={email}
        emailRepeat={emailRepeat}
        password={password}
        passwordRepeat={passwordRepeat}
        termsChecked={termsChecked}
        onInputChanged={handleInputChange}
        onTermsCheckedChanged={handleTermsChecked}
        onFormSubmit={handleJoinSubmit}
      />
    </StyledPaper>
  );
};

export default JoinComponent;